import { useEffect, useState } from 'react';
import { estimateVideoJob } from '../api/generateVideo.api';
import type { EstimateVideoInput } from '../types';

const DEBOUNCE_MS = 400;

/**
 * Exact server estimate (prices may depend on field values). Keeps the previous number while
 * loading and returns null when disabled or on error so the caller falls back to the local one.
 */
export function useServerEstimate(enabled: boolean, params: EstimateVideoInput): number | null {
  const [estimate, setEstimate] = useState<number | null>(null);
  const paramsKey = JSON.stringify(params);

  useEffect(() => {
    if (!enabled) {
      setEstimate(null);
      return;
    }
    const controller = new AbortController();
    const timer = setTimeout(() => {
      estimateVideoJob(JSON.parse(paramsKey) as EstimateVideoInput, controller.signal)
        .then((value) => setEstimate(typeof value === 'number' ? value : null))
        .catch(() => {
          if (!controller.signal.aborted) setEstimate(null);
        });
    }, DEBOUNCE_MS);
    return () => {
      clearTimeout(timer);
      controller.abort();
    };
  }, [enabled, paramsKey]);

  return estimate;
}
